const noAnswer = {
  noAnswer: 'Do not wish to answer'
};

export const USER_BOOLEAN_ENUM = {
  yes: 'YES',
  no: 'NO'
};

// Gender
export const USER_GENDER_ENUM = { // genderEnum
  male: 'Male',
  female: 'Female',
  nonBinary: 'Non-binary',
  notListed: 'Not Listed',
  noAnswerPref: 'Prefer not to answer'
};

// Employment Status
export const USER_EMPLOYMENT_ENUM = { // employmentStatusEnum
  ne: 'Employed (Not by Employer/Sponsor)', // new
  ee: 'Existing Employee', // existing
  ue: 'Unemployed'
};

// Employment Status
export const USER_EDUCATION_ENUM = { // educationLevelEnum
  grade8OrLess: '8th Grade or Less',
  grade9To12: '9th to 12th Grade',
  highSchoolOrGED: 'High School or GED',
  postSecondaryOrTechTraining: 'Post Secondary or Technical Training',
  someCollege: 'Some College',
  associatesDegree: "Associate's Degree",
  bachelorsDegree: "Bachelor's Degree",
  mastersDegree: "Master's Degree"
};

// DISABILITY
export const USER_DISABILITY_ENUM = { // disabilityEnum
  ...USER_BOOLEAN_ENUM,
  ...noAnswer
};

// CRIMINAL BACKGROUND
export const USER_CRIMINAL_BKG_ENUM = { // disabilityEnum
  ...USER_BOOLEAN_ENUM,
  noDisclose: 'Do Not Wish To Disclose'
};

// ETHNICITY
export const USER_ETHNICITY_ENUM = { // ethnicityEnum
  hispanicOrLatino: 'Hispanic or Latino',
  notHispanicOrLatino: 'Not Hispanic or Latino',
  ...noAnswer
};

// RACE
export const USER_RACE = { // raceEnum
  americanIndianOrAlaskaNative: 'American Indian or Alaska Native',
  asian: 'Asian',
  blackOrAfricanAmerican: 'Black or African American',
  nativeHawaiianOrPacificIslander: 'Native Hawaiian or Other Pacific Islander',
  white: 'White',
  ...noAnswer
};

// Veteran Status
export const USER_VETERAN_ENUM = { // veteranStatusEnum
  veteran: 'Veteran',
  nonVeteran: 'Non-Veteran',
  ...noAnswer
};

// Organization Referral
export const USER_REFERRAL_ENUM = { // orgReferralEnum
  none: 'None',
  youthBuild: 'Youth Build',
  preApprenticeshipProgram: 'Pre-Apprenticeship Program',
  hudStepUp: 'HUD/STEP-UP',
  technicalTrainingSchool: 'Technical Training School',
  paCareerLink: 'PA CareerLink®',
  militaryVeterans: 'Military Veterans',
  highSchool: 'High School',
  jobCorps: 'Job Corps',
  other: 'Other'
};

export const USER_CITIZEN_ENUM = { // citizenStatusEnum
  usCitizen: 'US Citizen',
  permAlien: 'Permanent Alien',
  tempAlien: 'Temporary Alien',
  refugee: 'Refugee',
  illegalAlien: 'Illegal Alien',
  nonUsCitizen: 'Non-US Citizen',
  unknown: 'Unknown'
}
